export const cidToAlias = {
  5526: "WW_MD", //A-Z of Outlet Brands
  1340: "WW_FP", //A-Z of Brands
  2373: "WW_Beauty", //A-Z of Beauty Brands
  1361: "MW_FP", //A-Z of Brands
  8420: "MW_MD" //A-Z of Outlet Brands
};
